import { keepPreviousData } from "@tanstack/react-query";
import { RouterOutputs, trpc } from "../trpc";

interface Input {
  search?: string;
  accountId?: string;
}

export type MemberOrTeam =
  RouterOutputs["member"]["searchMembersAndTeams"][number];

export function useQuerySearchMembersAndTeams({
  search,
  accountId,
}: Input = {}) {
  const members = trpc.member.searchMembersAndTeams.useQuery(
    { search, accountId },
    { placeholderData: keepPreviousData },
  );

  return {
    membersAndTeams: members.data || ([] as MemberOrTeam[]),
  };
}

export { type Member, type Team } from "@zapier/bff";
